export default __webpack_public_path__ + "static/media/door.59d08bcc.png";